import SearchBox from './Search';

export default SearchBox;
